module.exports = __webpack_public_path__ + "img/logo.e6608349.png";